import styles from "./HeroSection.module.css";
import heroImage from "../../../../../assets/hero_image_1.jpg";
import flag from "../../../../../assets/colombia_flag.png";
import { ReactComponent as DownloadIcon } from "../../../../../assets/icons/ic_download.svg";
import { useWidth } from "../../../../hooks/useWidht";
import { PrivacyPoliteModal } from "../PrivacyPoliteModal/PrivacyPoliteModal";
import { useState } from "react";
import { ANDROID_DOWNLOAD_LINK, ANDROID_DOWNLOAD_NAME } from "../../../../config/constants/download_link";

export const HeroSection = () => {
    const width = useWidth();
    const isMobile = width < 768;
    const [open, setOpen] = useState(false);
    
    return (
        <div className={styles.heroSection}>
            <div className={styles.heroText}>
                <div className={styles.textContainer}>
                    <h1>
                        Conecta con docentes en toda Colombia{" "}
                        <img
                            src={flag}
                            alt="Colombia Flag"
                            className={styles.flagImage}
                        />
                    </h1>

                    <p className={styles.heroTextParagraph}>
                        Si eres maestro y estás buscando cambiar tu lugar de
                        trabajo mediante un intercambio con otro colega,{" "}
                        <b>PermuLink</b>
                        &nbsp;te conecta con profesionales que están en la misma
                        situación.
                    </p>
                    <span className={styles.quote}>Por el momento solo disponible para dispositivos móviles Android.</span>
                </div>
                <a href={ANDROID_DOWNLOAD_LINK} className={styles.downloadButton} target="_blank">
                    ¡Descargala ahora!
                    <DownloadIcon className={styles.downloadIcon} />
                </a>
                {isMobile && (
                    <a onClick={() => setOpen(true)} className={styles.privacyPolicy}>
                        Consulta nuestra política de privacidad
                    </a>
                )}
            </div>

            <div className={styles.heroImage}>
                <img
                    src={heroImage}
                    alt="Hero Image"
                    style={{ width: "100%", height: "100%" }}
                />
            </div>
            <PrivacyPoliteModal isOpen={open} onClose={() => setOpen(false)} />
        </div>
    );
};
